import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Grid, Row, Col } from 'react-flexbox-grid'
import FormNewUser from '../../containers/FormNewUser'
import EditableTableUsers from '../../containers/EditableTableUsers'
import * as Constants from '../../../constants'
import { db } from '../../../config/Fire'
import LoadingPage from '../../components/LoadingPage'
import { Divider } from 'antd'
import Search from 'antd/lib/input/Search'
import { getUser } from '../../../reducers'
import './styles.css'

const usersRef = db.ref(`${Constants.MAIN_NODES.USERS}`)

function compareName (a, b) {
    // Validar que ambos objetos existan
    if (!a && !b) return 0
    if (!a) return 1
    if (!b) return -1
    
    // Validar que name exista y sea string, con conversión segura
    let nameA = ''
    let nameB = ''
    
    if (a && a.name != null) {
        nameA = String(a.name).toLowerCase()
    }
    if (b && b.name != null) {
        nameB = String(b.name).toLowerCase()
    }
    
    if (nameA < nameB) {
        return -1
    }
    if (nameA > nameB) {
        return 1
    }
    return 0
}

class Users extends Component {
    state = {
        usersMap: null,
        usersFiltered: null
    }

    getData = () => {
        usersRef.on('value', (usersSnap) => {
            const usersLoaded = {}
            if (usersSnap.exists() && usersSnap.val() !== null) {
                usersSnap.forEach(userSnap => {
                    const user = userSnap.val()
                    // Solo mostrar usuarios de tipo CLIENT y EMPLOYEE
                    if (user && user.userType && user.id && 
                        (user.userType === Constants.USER_TYPES.CLIENT || user.userType === Constants.USER_TYPES.EMPLOYEE)) {
                        usersLoaded[user.id] = user
                    }
                })
            }
            if (this.searchInput && this.searchInput.input && this.searchInput.input.state) {
                this.searchInput.input.state.value = ''
            }
            // Inicializar usersFiltered con los usuarios cargados para evitar llamar searchUser en el render
            const usersArray = Object.keys(usersLoaded)
                .map(key => usersLoaded[key])
                .filter(user => user != null && user.name != null && user.name !== undefined)
            usersArray.sort(compareName)
            this.setState({ usersMap: usersLoaded, usersFiltered: usersArray })
        })
        return (<LoadingPage/>)
    }

    componentWillUnmount () {
        usersRef.off('value')
    }

    renderUsersTable = usersFiltered => {
        var data = []
        // Manejar tanto arrays como objetos
        const usersArray = Array.isArray(usersFiltered) 
            ? usersFiltered 
            : Object.keys(usersFiltered).map(userKey => usersFiltered[userKey])
        
        usersArray.forEach(user => {
            if (user && user.name != null) {
                data.push({
                    ...user,
                    id: user.id,
                    name: user.name,
                    email: user.email,
                    phone: user.phone,
                    userType: Constants.userTypesMap[user.userType],
                    createDate: user.createDate,
                    enabled: user.enabled
                })
            }
        })
        // Filtrar elementos inválidos antes de ordenar
        data = data.filter(item => item != null && item.name != null)
        data.sort(compareName)
        return (<EditableTableUsers data={data}/>)
    }

    searchUser = (value) => {
        const { usersMap } = this.state
        if (usersMap) {
            var usersData = []
            for (var key in usersMap) {
                const user = usersMap[key]
                // Filtrar usuarios válidos con name definido
                if (user && user.name != null && user.name !== undefined) {
                    if (value === '' || 
                        (user.name && String(user.name).toLowerCase().indexOf(value.toLowerCase()) !== -1) || 
                        (user.email && user.email && String(user.email).toLowerCase().indexOf(value.toLowerCase()) !== -1)) {
                        usersData.push(user)
                    }
                }
            }
            // Filtrar cualquier elemento null/undefined antes de ordenar
            usersData = usersData.filter(user => user != null && user.name != null)
            usersData.sort(compareName)
            this.setState({ usersFiltered: usersData })
        }
    }

    validateUser = () => {
        if (this.props.user && this.props.user.id && Constants.VALID_USERS_IDS.includes(this.props.user.id)) {
            return true
        }
        return false
    }

    render () {
        const { usersMap, usersFiltered } = this.state
        return (
            <div>
                {
                    this.validateUser() ?
                        usersMap ?
                            <Grid className="usersCont">
                                <Divider>Nuevo usuario</Divider>
                                <Row center="xs">
                                    <Col xs={12}>
                                        <FormNewUser 
                                            allowedUserTypes={['CLIENT', 'EMPLOYEE']}
                                        />
                                    </Col>
                                </Row>
                                <Divider>Usuarios</Divider>
                                <Row center="xs">
                                    <Col xs={10} sm={6}>
                                        <Search ref={txt => this.searchInput = txt} style={{ marginBottom: '20px' }}
                                                placeholder="Nombre o correo electrónico del usuario"
                                                onSearch={(value) => this.searchUser(value)} enterButton/>
                                    </Col>
                                </Row>
                                <Row center="xs">
                                    <Col xs={12}>
                                        {
                                            usersFiltered !== null && usersFiltered !== undefined ?
                                                this.renderUsersTable(usersFiltered)
                                                :
                                                <LoadingPage/>
                                        }
                                    </Col>
                                </Row>
                            </Grid>
                            :
                            this.getData()
                        :
                        <h1 className='message'>No tiene permisos para acceder a esta sección</h1>
                }
            </div>
        )
    }
}

Users.propTypes = {}

const mapStateToProps = state => ({
    user: getUser(state)
})

export default connect(mapStateToProps)(Users)
